import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "del_icon",
  "use": "del_icon-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"del_icon\">\n<path d=\"M10,1.1c-4.9,0-8.9,4-8.9,8.9S5.1,19,10,19s8.9-4,8.9-8.9S14.9,1.1,10,1.1z M14.9,14.9c-0.2,0.2-0.5,0.2-0.7,0\n\tL10,10.7l-4.2,4.2c-0.2,0.2-0.5,0.2-0.7,0c-0.2-0.2-0.2-0.5,0-0.7L9.3,10L5.1,5.9c-0.2-0.2-0.2-0.5,0-0.7C5.3,5,5.6,5,5.8,5.2\n\tL10,9.3l4.2-4.2c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7L10.7,10l4.2,4.2C15.1,14.4,15.1,14.7,14.9,14.9z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id